
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'
import { ImagenesSatelitalesState } from '@/store/modules/imagenes-satelitales/types'
import { createArray } from '@/components/helpers/timelineArray'
import { assesImagenesSatelitalesImages } from '@/components/helpers/getImagenesSatelitalesOverlays'
import DesktopFooter from '@/components/DesktopFooter.vue'
import ImagenesSatelitalesFooter from '@/components/ImagenesSatelitalesFooter.vue'
import { preloadImages } from '@/components/helpers/preloadImages'
import { getEnvironments } from '@/environments'
import { checkWebp } from '@/components/helpers/checkWebp'
const env = getEnvironments()

const IMAGENES_SATELITALES = 'imagenesSatelitales'
const GOOGLE_MAPS_MODULE = 'googleMaps'

@Component({
  components: {
    ImagenesSatelitalesFooter,
    DesktopFooter
  }
})
export default class ImagenesSatelitales extends Vue {
  @State(IMAGENES_SATELITALES) public imagenesSatelitales!: ImagenesSatelitalesState;
  @Action('getImagenesSatelitales', { namespace: IMAGENES_SATELITALES })
  private getImagenesSatelitales: any
  @Action('setOverlayViews', { namespace: GOOGLE_MAPS_MODULE })
  private setOverlayViews: any
  @Action('setPosition', { namespace: GOOGLE_MAPS_MODULE })
  private setPosition: any
  @Prop() private type!: string
  private timelineList: any[] = []
  private currentPosition: number = 0
  private baseImageUrl: string = env.url.IMG

  getData () {
    // Get the data from the store
    return this.getImagenesSatelitales()
  }

  get computedTimelineList () {
    const { delta: deltaHoras = 0, inicio: fechaInicio = '' } = this.imagenesSatelitales.timeline_config[this.type] || {}
    if (this.imagenesSatelitales.delta > 0) this.timelineList = createArray(this.imagenesSatelitales, deltaHoras, fechaInicio)
    return this.timelineList
  }

  setOverlays ({ position }: { position: number }) {
    if (assesImagenesSatelitalesImages(this.imagenesSatelitales) && this.imagenesSatelitales.pasos > 0 && this.type) {
      const overlays: any[] = []
      const currentItem = position
      const { ruta, latlong, imagenes }: { ruta: string, latlong: any, imagenes: any} = this.imagenesSatelitales
      const bounds = {
        south: latlong[0][0],
        north: latlong[1][0],
        west: latlong[0][1],
        east: latlong[1][1]
      }

      imagenes[this.type].forEach((image: string, index: number) => {
        const srcImage = `${this.baseImageUrl}${ruta}/${image}`

        overlays.push({
          bounds,
          image: srcImage,
          isShown: currentItem === index
        })
      })
      this.setOverlayViews(overlays)
      this.currentPosition = currentItem
    }
  }

  async created () {
    await this.getData()
    preloadImages(this.baseImageUrl, this.imagenesSatelitales)
    const position = {
      lat: this.imagenesSatelitales.centro[0],
      lng: this.imagenesSatelitales.centro[1]
    }
    const zoom = env.settings.IMAGENES_SATELITALES.zoom
    this.setPosition({ position, zoom })
  }
  beforeDestroy () {
    this.setOverlayViews([])
  }
}
